module.exports = __webpack_public_path__ + "img/logo.c47445ac.svg";